// This function allow to reference chunks
__webpack_require__.u = function(chunkId) {
  // return url for filenames not based on template
  if (chunkId === 70) return "js/70-b97387f039afc51d.js";
  // return url for filenames based on template
  return "js/" + ({592: "logrocket",712: "echarts",}[chunkId] || chunkId) + "-" + {43: "e6d78e8b11c02f6c",580: "73e4aa59d8d48ec1",592: "391a9ca13585c76e",679: "cd04c8d98b7fd3a5",696: "0faf73d09c029410",712: "b22f512c380015fd",}[chunkId] + ".chunk.js"
}